import React from "react";
import { AGENT } from "@/lib/site";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--vp-border)]"
      style={{ background: "var(--vp-text)", color: "rgba(255,255,255,0.85)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span
              className="inline-flex h-9 w-9 items-center justify-center rounded-xl text-white"
              style={{ background: "var(--vp-primary)" }}
            >
              <ShieldCheck size={20} />
            </span>
            <span className="font-display font-bold text-lg">{AGENT.company}</span>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            Neodvisno zavarovalno in finančno svetovanje za posameznike in podjetja.
            Reševanje odškodninskih primerov.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-white/50 font-semibold mb-3">
            Kontakt
          </div>
          <ul className="space-y-2 text-sm">
            <li>{AGENT.phone}</li>
            <li>{AGENT.email}</li>
            <li>{AGENT.hoursInfo}</li>
            <li className="text-[#a3d4b8]">{AGENT.hoursEmergency}</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-white/50 font-semibold mb-3">
            Hitre povezave
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="#storitve" className="hover:text-white">Storitve</a></li>
            <li><a href="#kalkulatorji" className="hover:text-white">Kalkulatorji</a></li>
            <li><a href="#dokumenti" className="hover:text-white">Pomoč</a></li>
            <li><a href="#kontakt" className="hover:text-white">Kontakt</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} {AGENT.company}. Vse pravice pridržane.
      </div>
    </footer>
  );
}
